import React, { useMemo, useState } from 'react';

import Axios from 'axios';

import styled from 'styled-components';

import { NwLinkButton } from '@components/Gui/NwButton';
import NwIcon from '@components/Gui/NwIcon';
import StyleVariables from '@components/Gui/StyleVariables';
import { useMailingListContext } from '@components/MailingLists/MailingListContext';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    small {
        color: ${(props) => props.theme.TextColorMuted};
        text-transform: uppercase;
        font-size: ${StyleVariables.FontSizeSmall};
        display: block;
    }

    p {
        margin: 0;
        color: ${(props) => props.theme.TextColorMuted};
    }

    .other-emails {
        margin-top: 1rem;
    }
`;

const normalizeEmailAddress = (email) => (email || '').trim().toLowerCase();

const ModelsTableColumnEmails = ({ model }) => {
    const { mailingListEmailSet, onAddItem } = useMailingListContext();

    const [otherEmails, setOtherEmails] = useState([]);
    const [lookingForOtherEmails, setLookingForOtherEmails] = useState(null);
    const [addedEmails, setAddedEmails] = useState([]);

    const addedEmailSet = useMemo(() => new Set(addedEmails), [addedEmails]);

    const isEmailAlreadyAdded = (email) => {
        const normalizedEmail = normalizeEmailAddress(email);
        return mailingListEmailSet.has(normalizedEmail) || addedEmailSet.has(normalizedEmail);
    };

    const loadAddresses = async () => {
        setLookingForOtherEmails('loading');
        const emails = await Axios.post(`/contacts/connections/emails`, { ContactIDs: [model.ID] });
        if (emails && emails.length > 0) {
            setOtherEmails(
                emails.filter(
                    (e) =>
                        e.EmailID !== model.EI && e.Email && model.E && e.Email.toLowerCase() !== model.E.toLowerCase()
                )
            );
        }
        setLookingForOtherEmails(true);
    };

    const handleAddEmail = (emailID, emailAddress) => {
        const normalizedEmail = normalizeEmailAddress(emailAddress);
        setAddedEmails((current) => (current.includes(normalizedEmail) ? current : [...current, normalizedEmail]));
        onAddItem({ EmailID: emailID });
    };

    return (
        <Wrapper>
            <small>default e-mail</small>
            {model.E ? (
                isEmailAlreadyAdded(model.E) ? (
                    <NwLinkButton
                        primary
                        disabled
                        label={model.E}
                        onClick={() => {}}
                        icon={byPrefixAndName.fass['check']}
                    />
                ) : (
                    <NwLinkButton
                        primary
                        label={model.E}
                        onClick={() => handleAddEmail(model.EI, model.E)}
                        icon={byPrefixAndName.fass['circle-plus']}
                    />
                )
            ) : (
                <p>
                    <NwIcon style={{ color: StyleVariables.DangerColor }} icon={byPrefixAndName.fasl['ban']} />
                    &nbsp; no default e-mail set
                </p>
            )}
            <div className="other-emails">
                {lookingForOtherEmails ? (
                    lookingForOtherEmails === 'loading' ? (
                        <p>Loading...</p>
                    ) : (
                        <div className="other-emails-list">
                            {otherEmails.length === 0 ? (
                                <p>No other e-mails found</p>
                            ) : (
                                otherEmails.map((email) => (
                                    <div className="other-emails-item" key={email.EmailID}>
                                        {isEmailAlreadyAdded(email.Email) ? (
                                            <NwLinkButton
                                                disabled
                                                label={email.Email}
                                                onClick={() => {}}
                                                icon={byPrefixAndName.fass['check']}
                                            />
                                        ) : (
                                            <NwLinkButton
                                                primary
                                                label={email.Email}
                                                onClick={() => handleAddEmail(email.EmailID, email.Email)}
                                                icon={byPrefixAndName.fass['circle-plus']}
                                            />
                                        )}
                                    </div>
                                ))
                            )}
                        </div>
                    )
                ) : (
                    <NwLinkButton
                        //ghost
                        black
                        icon={byPrefixAndName.fasl['envelopes']}
                        label="Show all e-mails"
                        onClick={loadAddresses}
                    />
                )}
            </div>
        </Wrapper>
    );
};

export default ModelsTableColumnEmails;
